// extracted by mini-css-extract-plugin
export default {"middleEllipsis":"styles_middleEllipsis__HXu6+","left":"styles_left__Th9jN","right":"styles_right__7+2R-","inFlexParent":"styles_inFlexParent__cVRWk"};